module.exports = __webpack_public_path__ + "img/green_128.29aa3785.png";